import * as React from 'react';
import { replacePlaceholders, __ } from '../../helpers/TranslationService';
import styled from '@emotion/styled';

interface IOptionsComponent {
    option: {
        value: string;
        label?: string;
        id: number;
        type: string;
        maxDiscount?: number;
    };
    onSelect: (val: number) => void;
}

const CabinValueStyled = styled.div`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-left: 16px;
`;

const CabinOptionStyled = styled.div`
    color: ${({ theme }) => theme.text.color.primary};
    font-size: 14px;
    padding: 10px 16px;
    & + & {
        border-top: 1px solid ${({ theme }) => theme.colors.iron[100]};
    }
`;

const CabinOptionDiscountStyled = styled.div`
    color: ${({ theme }) => theme.colors.watermelon[100]};
    font-size: 12px;
    font-weight: 700;
    line-height: 22px;
`;

export const CabinOptionComponent = (props: IOptionsComponent) => {
    const handleClick = () => props.onSelect(props.option.id);

    const discountText = replacePlaceholders(__('upToXDiscount', 'dreamlines'), [
        `-${props.option.maxDiscount}%`,
    ]);

    return (
        <CabinOptionStyled onClick={handleClick}>
            <span>{props.option.label}</span>
            {props.option.maxDiscount && (
                <CabinOptionDiscountStyled>{discountText}</CabinOptionDiscountStyled>
            )}
        </CabinOptionStyled>
    );
};

export const CabinValueComponent = (props) => (
    <CabinValueStyled>{props.value.label}</CabinValueStyled>
);
